import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
// import { AgentDashboard } from './components';
const AgentDashboard = lazy(()=> import(/* webpackChunkName: "agentdashboard" */"./components"))

const routes = () => <PrivateRoute exact path="/agent-dashboard" component={AgentDashboard} />;

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/agentdashboard/AgentDashboard/routes.js